import type { FormationId } from "../domain/club";

export type RouteId =
  | "home"
  | "onboarding"
  | "play"
  | "setup"
  | "club"
  | "identity"
  | "players"
  | "player"
  | "tactics"
  | "activities"
  | "profile"
  | "more"
  | "settings"
  | "match"
  | "results";

export type GraphicsPreset = "auto" | "low" | "balanced" | "high";
export type CameraPreset = "broadcast" | "dynamic" | "tactical" | "player";

export interface ClubState {
  name: string;
  shortName: string;
  primaryColor: string;
  secondaryColor: string;
  formation: FormationId;
}

export interface GuestSession {
  schemaVersion: 1;
  guestId: string;
  displayName: string;
  locale: "en" | "id";
  xp: number;
  club: ClubState;
  onboardingComplete: boolean;
}

export interface GameSettings {
  schemaVersion: 1;
  graphicsPreset: GraphicsPreset;
  reducedMotion: boolean;
  cameraShake: boolean;
  cameraPreset: CameraPreset;
  leftHanded: boolean;
  controlScale: number;
  controlOpacity: number;
  floatingJoystick: boolean;
  radarEnabled: boolean;
  ballVisibility: "authentic" | "high";
}

export const DEFAULT_SETTINGS: GameSettings = {
  schemaVersion: 1,
  graphicsPreset: "auto",
  reducedMotion: false,
  cameraShake: true,
  cameraPreset: "broadcast",
  leftHanded: false,
  controlScale: 1,
  controlOpacity: 0.72,
  floatingJoystick: true,
  radarEnabled: true,
  ballVisibility: "high"
};

export const DEFAULT_CLUB: ClubState = {
  name: "Kips United",
  shortName: "KIP",
  primaryColor: "#66f04f",
  secondaryColor: "#09221a",
  formation: "4-3-3"
};
